<div class="crd-join-backdrop">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        Connecting to {{ hostName }}
        <small class="text-muted" style="margin-left: 0.5em">Screen {{ monitor + 1 }}</small>
      </div>
      <div class="modal-body">
        @if (error()) {
          <div class="cl-alert cl-alert-danger" role="alert">
            <i class="fas fa-exclamation-triangle"></i> {{ error() }}
          </div>
        } @else {
          <div style="text-align: center; padding: 1rem 0">
            <div class="cl-spinner">{{ status() }}<i class="fas fa-spinner fa-spin"></i></div>
          </div>
        }
      </div>
      <div class="modal-footer">
        @if (error()) {
          <span class="modal-footer-left">
            <button type="button" class="btn cl-color-secondary" (click)="goBack()"><span>Cancel</span></button>
          </span>
          <span class="modal-footer-center"></span>
          <span class="modal-footer-right">
            <button type="button" class="btn cl-color-primary" (click)="retry()"><span>Try Again</span></button>
          </span>
        } @else {
          <span class="modal-footer-left"></span>
          <span class="modal-footer-center">
            <button type="button" class="btn cl-color-primary" (click)="goBack()"><span>Cancel</span></button>
          </span>
          <span class="modal-footer-right"></span>
        }
      </div>
    </div>
  </div>
</div>
